// Modelo Monitoreo Dinámico para administrador.
export default class PatientMonitoring {
    id=""
    program=""
    form=""
    date=""
    value=""
    patientRouteSheet=""
}



// WEBPACK FOOTER //
// ./src/model/PatientMonitoring.js